module.exports = __webpack_public_path__ + "static/media/Cliente1.b96cf500.png";